module.exports = __webpack_public_path__ + "static/img/bell.3e0ad528.svg";